import React, {Component, useContext} from 'react';
import Typography from "@material-ui/core/Typography";
import {
    ResponsiveContainer,
} from "recharts";
import AppContext from '../../AppContext'
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import {ResponsiveSunburst} from "@nivo/sunburst";
import {get} from 'lodash';



const SunburstPanel = props => {
    const context = useContext(AppContext);
    let formatSpecData = (specs) => {
        let res = {"name": "Restraints map", "children": []};
        for (let spec of specs) {
            res.children.push({
                "name": get(spec, 'name'),
                "children": [
                    {
                        "name": "ambiguous",
                        "children": [
                            {
                                "name": "unviolated",
                                "loc": get(spec, 'ambiguous.used') - get(spec, 'ambiguous.violated')
                            },
                            {
                                "name": "violated",
                                "loc": get(spec, 'ambiguous.violated')
                            },
                        ]
                    },
                    {
                        "name": "unambiguous",
                        "children": [
                            {
                                "name": "unviolated",
                                "loc": get(spec, 'unambiguous.used') - get(spec, 'unambiguous.violated')
                            },
                            {
                                "name": "violated",
                                "loc": get(spec, 'unambiguous.violated')
                            },
                        ]
                    }
                ]
            })
        }
        return res
    };
    return (
        <Card>
            <CardContent>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom>
                    Restraints map
                </Typography>
                <ResponsiveContainer
                    width="100%"
                    height={450}
                >
                    <ResponsiveSunburst
                        data={formatSpecData(get(context, `state.data.iterations.${context.state.iteration_id}.spectra`))}
                        margin={{top: 40, right: 20, bottom: 20, left: 20}}
                        identity="name"
                        value="loc"
                        cornerRadius={2}
                        borderWidth={3}
                        borderColor="white"
                        colors={{scheme: 'paired'}}
                        childColor={{from: 'color'}}
                        animate={true}
                        motionStiffness={90}
                        motionDamping={15}
                        isInteractive={true}
                    />
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};

export default SunburstPanel;